import { ReactNode } from 'react';

interface FormGroupProps {
  title: string;
  description?: string;
  children: ReactNode;
}

const FormGroup = ({ title, description, children }: FormGroupProps) => {
  return (
    <div className="mb-8 p-6 bg-white rounded-lg shadow-sm">
      <h3 className="text-xl font-heading font-semibold text-primary-800 mb-3">{title}</h3>
      {description && <p className="text-gray-600 mb-4">{description}</p>}
      <div className="space-y-4">
        {children}
      </div>
    </div>
  );
};

export default FormGroup;